import videojs from 'video.js';
import store from 'store';
import merge from 'lodash/merge';
import toast from '../../../lib/toast/toast';
const KEY = 'key';
const MOVE_KEY = 'move';
const RESUME_KEY = 'positions';
// key から position の値を取得してユーザに問い合わせる。
function resume(player, { message, key, buttons }) {
    return new Promise(resolve => {
        const positions = store.get(RESUME_KEY);
        if (!positions) {
            return resolve();
        }
        if (!positions[key]) {
            return resolve();
        }
        const position = positions[key];
        toast.question({
            message: message(position),
            timeout: 0,
            position: 'center',
            overlay: true,
            buttons: [
                [
                    `<button>${buttons.resume}</button>`,
                    (instance, toast) => {
                        instance.hide({ transitionOut: 'fadeOut' }, toast, MOVE_KEY);
                    },
                    true,
                ],
                [
                    `<button>${buttons.reset}</button>`,
                    (instance, toast) => {
                        instance.hide({ transitionOut: 'fadeOut' }, toast);
                    },
                    false,
                ],
            ],
            onClosing: (instance, toast, closedBy) => {
                if (closedBy === MOVE_KEY) {
                    resolve(position);
                }
                else {
                    resolve();
                }
            },
        });
    });
}
// key に position の値を保存する
function persist(key, position) {
    const positions = store.get(RESUME_KEY);
    const newPositions = merge({}, positions, { [key]: position });
    store.set(RESUME_KEY, newPositions);
}
// safari では readyState が 1 だと currentTime を設定できない。
// 2: loadedmetadata 以上になったときに currentTime が設定できる。
function waitMetadata(player) {
    const wait = (resolve) => {
        if (player.readyState() >= 2) {
            resolve();
        }
        else {
            setTimeout(() => {
                wait(resolve);
            }, 300);
        }
    };
    return new Promise(wait);
}
videojs.registerPlugin(KEY, function (options) {
    if (options.enabled) {
        const update = () => {
            if (!this.error()) {
                const position = Math.trunc(this.currentTime());
                persist(options.key, position);
            }
        };
        this.ready(() => {
            Promise.all([resume(this, options), waitMetadata(this)])
                .then(([position]) => {
                if (position) {
                    this.currentTime(Math.trunc(position));
                }
                this.on('timeupdate', update);
                this.one('dispose', () => {
                    this.off('timeupdate', update);
                });
                if (options.autoplay) {
                    this.play();
                }
            })
                .catch(error => {
                console.error(error);
            });
        });
    }
});
export default KEY;
